export enum ConversionIncome {
  KIRIM = 1,
  CHIQIM = -1
}
